export const adEstate = {
  'ad_estate.sidebar.cta.write_message': 'Napsat zprávu',
  'ad_estate.sidebar.cta.mortgage': 'Spočítat splátky',
  'ad_estate.sidebar.cta.travel': 'Domluvit prohlídku',
  'ad_estate.sidebar.cta.contact_seller': 'Kontaktovat makléře',

  'ad_estate.sidebar.inactive':
    '<strong>Staženo:</strong> Tato nemovitost byla stažená z inzerce a již není dostupná.',

  'ad_estate.sidebar.title': `Prodej {subType, select,
    hut {chaty}
    cottage {chalupy}
    family {rodinného domu}
    building_plot {stavebního pozemku}
    other {bytu}
   }`,

  'ad_estate.sidebar.land': 'pozemek',

  'ad_estate.sidebar.photos.tab_name': 'Fotky',
  'ad_estate.sidebar.map': 'Mapa',

  'ad_estate.sidebar.more_adEstates': `Zobrazit {count, plural,
     =1 {další}
     =2 {další}
     =3 {další}
     =4 {další}
      other {dalších}} {count} {count, plural,
        =1 {nemovitost}
        =2 {nemovitosti}
        =3 {nemovitosti}
        =4 {nemovitosti}
        other {nemovitostí}} {locality, select,
     true {v lokalitě {localityName}}
     other {}
    }`,

  'ad_estate.unit_detail.title': 'Podrobnosti',
  'ad_estate.building_detail.title': 'Podrobnosti',
  'ad_estate.parcel_detail.title': 'Podrobnosti',

  // Mortgage section
  'ad_estate.sidebar.mortgage_section.text':
    'Výhodné splátky měsíčně od <b>{price}</b>',

  // Unit additional info
  'ad_estate.additional_info.subtitle.basic': 'Základní údaje',
  'ad_estate.additional_info.subtitle.conditions': 'Stav',
  'ad_estate.additional_info.subtitle.amenities': 'Příslušenství',
  'ad_estate.additional_info.subtitle.additional_info': 'Doplňující informace',
  'ad_estate.additional_info.subtitle.building': 'Budova',
  'ad_estate.additional_info.edit': 'Upravit údaje',
  'ad_estate.additional_info.area': 'Podlahová plocha',
  'ad_estate.additional_info.reference_id': 'ID zakázky',
  'ad_estate.additional_info.price': 'Cena',
  'ad_estate.additional_info.price_description': 'Poznámka k ceně',
  'ad_estate.additional_info.floor_area': 'Podlahová plocha',
  'ad_estate.additional_info.disposition': 'Dispozice',
  'ad_estate.additional_info.ownership': 'Typ vlastnictví',
  'ad_estate.additional_info.floor_number': 'Podlaží',
  'ad_estate.additional_info.condition': 'Stav',
  'ad_estate.additional_info.balcony': 'Balkon',
  'ad_estate.additional_info.loggia': 'Lodžie',
  'ad_estate.additional_info.terrace': 'Terasa',
  'ad_estate.additional_info.cellar': 'Sklep',
  'ad_estate.additional_info.garage': 'Garáž',
  'ad_estate.additional_info.parking_space': 'Parkovací místa',
  'ad_estate.additional_info.garden': 'Zahrada',
  'ad_estate.additional_info.heating_kind': 'Topení',
  'ad_estate.additional_info.accessibility': 'Bezbariérový přístup',

  // Unit additional info - ownership
  'ad_estate.additional_info.ownership.private': 'Osobní',
  'ad_estate.additional_info.ownership.collective': 'Družstevní',
  'ad_estate.additional_info.ownership.national_or_municipal': 'Státní/obecní',
  'ad_estate.additional_info.ownership.mixed': 'Smíšené',
  'ad_estate.additional_info.ownership.other': 'Jiné',

  // Unit additional info - heating kind
  'ad_estate.additional_info.heating_kind.central_internal':
    'Centrální domovní',
  'ad_estate.additional_info.heating_kind.central_external':
    'Centrální dálkové',
  'ad_estate.additional_info.heating_kind.local': 'Lokální',
  'ad_estate.additional_info.heating_kind.other': 'Jiné (i bez topení)',
  'ad_estate.additional_info.heating_kind.solid_fuels':
    'Vytápění tuhými palivy',
  'ad_estate.additional_info.heating_kind.gas': 'Plynové topení',
  'ad_estate.additional_info.heating_kind.electric': 'Elektrické topení',
  'ad_estate.additional_info.heating_kind.heat_pump': 'Tepelná čerpadla',
  'ad_estate.additional_info.heating_kind.heat_network': 'Ústřední topení',
  'ad_estate.additional_info.heating_kind.stove_fireplace':
    'Lokální kamna a krby',

  // conditions
  'ad_estate.additional_info.kitchen_condition': 'Stav kuchyně',
  'ad_estate.additional_info.bathroom_condition': 'Stav koupelny',
  'ad_estate.additional_info.rooms_condition': 'Stav pokojů',

  'ad_estate.additional_info.construction_kind': 'Typ konstrukce',
  'ad_estate.additional_info.elevator': 'Výtah',
  'ad_estate.additional_info.floors': 'Počet podlaží',
  'ad_estate.additional_info.energy_performance': 'Energ. náročnost budovy',

  // Energy performance
  'ad_estate.additional_info.energy_performance.A': 'A',
  'ad_estate.additional_info.energy_performance.B': 'B',
  'ad_estate.additional_info.energy_performance.C': 'C',
  'ad_estate.additional_info.energy_performance.D': 'D',
  'ad_estate.additional_info.energy_performance.E': 'E',
  'ad_estate.additional_info.energy_performance.F': 'F',
  'ad_estate.additional_info.energy_performance.G': 'G',

  // Construction kinds
  'ad_estate.additional_info.construction_kind.brick': 'Cihla',
  'ad_estate.additional_info.construction_kind.brick_cinder_block': 'Cihla',
  'ad_estate.additional_info.construction_kind.stone': 'Cihla',
  'ad_estate.additional_info.construction_kind.brick_stone': 'Cihla',
  'ad_estate.additional_info.construction_kind.panel': 'Panel',
  'ad_estate.additional_info.construction_kind.mudbrick': 'Cihla',
  'ad_estate.additional_info.construction_kind.wooden': 'Dřevo',
  'ad_estate.additional_info.construction_kind.other': 'Jiný',
  'ad_estate.additional_info.construction_kind.brick_stone_cinder_block':
    'Cihla',
  'ad_estate.additional_info.construction_kind.monolith': 'Monolit',

  // Building additional info
  'ad_estate.additional_info.subtitle.areas': 'Plochy',
  'ad_estate.additional_info.subtitle.parking': 'Parkování',
  'ad_estate.additional_info.land_area': 'Plocha pozemku',
  'ad_estate.additional_info.house_separation': 'Poloha domu',

  // house separation type
  'ad_estate.additional_info.house_separation.stand_alone':
    'Samostatně stojící',
  'ad_estate.additional_info.house_separation.terraced': 'Řadový / v bloku',
  'ad_estate.additional_info.house_separation.corner': 'Rohový',

  // Elevator
  'ad_estate.additional_info.elevator.has_elevator': 'Ano',
  'ad_estate.additional_info.elevator.no_elevator': 'Ne',

  'ad_estate.additional_info.sub_type': 'Typ budovy',
  'ad_estate.additional_info.sub_type.apartment_building': 'Bytový dům',
  'ad_estate.additional_info.sub_type.apartments': 'Bytový dům',
  'ad_estate.additional_info.sub_type.housing': 'Objekt k bydlení',
  'ad_estate.additional_info.sub_type.family': 'Rodinný dům',
  'ad_estate.additional_info.sub_type.industrial_building': 'Průmyslový objekt',
  'ad_estate.additional_info.sub_type.farmstead': 'Zemědělská usedlost',
  'ad_estate.additional_info.sub_type.amenities': 'Objekt občanské vybavenosti',
  'ad_estate.additional_info.sub_type.forest': 'Objekt lesního hospodářství',
  'ad_estate.additional_info.sub_type.warehouses':
    'Stavba pro výrobu a skladování',
  'ad_estate.additional_info.sub_type.bussiness_building': 'Stavba pro obchod',
  'ad_estate.additional_info.sub_type.offices': 'Stavba pro administrativu',
  'ad_estate.additional_info.sub_type.agricultural': 'Zemědělská stavba',
  'ad_estate.additional_info.sub_type.transport_building': 'Stavba pro dopravu',
  'ad_estate.additional_info.sub_type.garage': 'Garáž',
  'ad_estate.additional_info.sub_type.garage_slot': 'Parkovací místo',
  'ad_estate.additional_info.sub_type.other': 'Jiná stavba',
  'ad_estate.additional_info.sub_type.other_house': 'Jiná stavba',
  'ad_estate.additional_info.sub_type.other_commercial':
    'Jiná komereční stavba',
  'ad_estate.additional_info.sub_type.other_land': 'Jiné',
  'ad_estate.additional_info.sub_type.multifunctional_building':
    'Víceúčelová stavba',
  'ad_estate.additional_info.sub_type.greenhouse': 'Skleník, pařeniště',
  'ad_estate.additional_info.sub_type.barrage': 'Jez',
  'ad_estate.additional_info.sub_type.tailings_dam': 'Stavba odkaliště',
  'ad_estate.additional_info.sub_type.unfinished': 'Rozestavěné jednotky',
  'ad_estate.additional_info.sub_type.unknown': 'Neznámý typ',
  'ad_estate.additional_info.sub_type.attic': 'Podkroví',
  'ad_estate.additional_info.sub_type.building_plot': 'Stavební pozemek',
  'ad_estate.additional_info.sub_type.commercial_land': 'Komereční pozemek',
  'ad_estate.additional_info.sub_type.commercial_space': 'Komereční prostory',
  'ad_estate.additional_info.sub_type.cottage': 'Chalupa',
  'ad_estate.additional_info.sub_type.hut': 'Chata',
  'ad_estate.additional_info.sub_type.doctors_office': 'Lékařská ordinace',
  'ad_estate.additional_info.sub_type.manufacturing_plant': 'Výrobní závod',
  'ad_estate.additional_info.sub_type.multigenerational_house': 'Generační dům',
  'ad_estate.additional_info.sub_type.pond': 'Rybník',
  'ad_estate.additional_info.sub_type.project': 'Projekt',
  'ad_estate.additional_info.sub_type.restaurant': 'Restaurace',
  'ad_estate.additional_info.sub_type.room': 'Pokoj',
  'ad_estate.additional_info.sub_type.vineyard': 'Vinice',
  'ad_estate.additional_info.sub_type.wine_cellar': 'Vinný sklep',
  'ad_estate.additional_info.sub_type.mobilheim': 'Mobilní dům',
  'ad_estate.additional_info.sub_type.field': 'Pole',
  'ad_estate.additional_info.sub_type.meadow': 'Louka',
  'ad_estate.additional_info.sub_type.gardens': 'Zahrada',
  'ad_estate.additional_info.sub_type.villa': 'Vila',

  'ad-estate.cta.back': 'Zpět',

  // Modal
  'ad-estate.message_sent.modal.title': 'Napsat zprávu prodejci',
  'ad-estate.message_sent.modal.input.label': 'Email',
  'ad-estate.message_sent.modal.input_area.label': 'Vaše zpráva',
  'ad-estate.message_sent.modal.input_area.min':
    'Zpráva musí mít alespoň 5 znaků',
  'ad-estate.message_sent.modal.input.placeholder':
    'Email na který vám prodejce odepíše',

  'ad-estate.message_sent.modal.cta.back': 'Zpět',
  'ad-estate.message_sent.modal.cta.sent': 'Odeslat zprávu',
  'ad-estate.message_sent.modal.error':
    'Zprávu se nepodařilo odeslat. Zkuste to prosím znovu později.',
  'ad-estate.message_sent.modal.validation.required.message':
    'Vyplňte prosím zprávu',

  'ad-estate.message_sent.modal.result.title': 'Zpráva odeslána',
  'ad-estate.message_sent.modal.result.subtitle': 'Odpověď příjde na:',
  'ad-estate.message_sent.modal.result.cta.back': 'Zavřít',

  'ad-estate.arrange_tour.modal.title':
    'Pro spojení s makléřem vyplňte kontaktní údaje',
  'ad-estate.arrange_tour.modal.cta.sent': 'Odeslat žádost',
  'ad-estate.arrange_tour.modal.error':
    'Zprávu se nepodařilo odeslat. Zkuste to prosím znovu později.',

  'ad-estate.arrange_tour.modal.input.full_name.label': 'Jméno a příjmení',
  'ad-estate.arrange_tour.modal.input.full_name.placeholder':
    'Vaše jméno a příjmení',
  'ad-estate.arrange_tour.modal.input.email.label': 'Email',
  'ad-estate.arrange_tour.modal.input.email.placeholder':
    'Email na který vám makléř odepíše',
  'ad-estate.arrange_tour.modal.input.phone.label': 'Telefon',
  'ad-estate.arrange_tour.modal.input.phone.placeholder': '+420 789 654 123',
  'ad-estate.arrange_tour.modal.input.phone.valid':
    'Vyplňte prosím platný telefon (např. ve tvaru 777888999, nebo +420 777 888 999)',
  'ad-estate.arrange_tour.modal.textarea.message.label':
    'Vaše zpráva (nepovinné)',

  'ad-estate.arrange_tour.modal.text':
    'Odesláním formuláře souhlasím s <terms>obchodními podmínkami</terms> a se <gdpr>zpracováním osobních údajů</gdpr>.',

  'ad-estate.arrange_tour.modal.mortgage.title':
    'Máte zájem o hypotéku s nejvýhodnějším úrokem?',
  'ad-estate.arrange_tour.modal.mortgage.error':
    'Žádost se nepodařilo odeslat. Zkuste to prosím znovu později.',
  'ad-estate.arrange_tour.modal.mortgage.success_message':
    'Odesláno, prodejce vás brzy kontaktuje ohledně prohlídky.',

  'ad-estate.arrange_tour.modal.result.title': 'Úspešně odesláno',
  'ad-estate.arrange_tour.modal.result.subtitle':
    'Brzy se s vámi spojí hypoteční specialista a zjistíte své možnosti financování.',
  'ad-estate.arrange_tour.modal.result.cta.back': 'Zavřít',

  'ad-estate.mortgage_form.modal.title':
    'Pro získání nejvýhodnější hypotéky vyplňte kontaktní údaje',
  'ad-estate.mortgage_form.modal.cta.sent': 'Domluvit prohlídku',
  'ad-estate.mortgage_form.modal.error':
    'Zprávu se nepodařilo odeslat. Zkuste to prosím znovu později.',

  'ad-estate.mortgage_form.modal.input.full_name.label': 'Jméno a příjmení',
  'ad-estate.mortgage_form.modal.input.full_name.placeholder':
    'Vaše jméno a příjmení',
  'ad-estate.mortgage_form.modal.input.email.label': 'Email',
  'ad-estate.mortgage_form.modal.input.email.placeholder':
    'Email na který vám prodejce odepíše',
  'ad-estate.mortgage_form.modal.input.phone.label': 'Telefon',
  'ad-estate.mortgage_form.modal.input.phone.placeholder': '+420 789 654 123',
  'ad-estate.mortgage_form.modal.input.phone.valid':
    'Vyplňte prosím platný telefon (např. ve tvaru 777888999, nebo +420 777 888 999)',
  'ad-estate.mortgage_form.modal.textarea.message.label':
    'Vaše zpráva (nepovinné)',

  'ad-estate.mortgage_form.modal.text':
    'Odesláním formuláře souhlasím s <terms>obchodními podmínkami</terms> a se <gdpr>zpracováním osobních údajů</gdpr>.',

  'ad-estate.mortgage_form.modal.mortgage.title':
    'Máte zájem o hypotéku s nejvýhodnějším úrokem?',
  'ad-estate.mortgage_form.modal.mortgage.error':
    'Žádost se nepodařilo odeslat. Zkuste to prosím znovu později.',
  'ad-estate.mortgage_form.modal.mortgage.success_message':
    'Doufáme, že jste se v pořádku spojili s prodávajícím makléřem.',

  'ad-estate.mortgage_form.modal.result.title': 'Úspešně odesláno',
  'ad-estate.mortgage_form.modal.result.subtitle':
    'Brzy se s vámi spojí hypoteční specialista a zjistíte své možnosti financování.',
  'ad-estate.mortgage_form.modal.result.cta.back': 'Zavřít',
};
